import { Popover } from '@fiverr-private/fit';
import { SOURCES } from '../reports/consts';

export { parseSingleListingResponse } from '../../api/utils';
export const WORDS_TO_SHOW_MORE = 11;
export const NOTABLE_CLIENTS_LIMIT = 5;

export const STATUSES = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
};

export const EDIT_STATUSES = {
    ENABLED: 'ENABLED',
    PENDING: 'PENDING',
    DECLINED: 'DECLINED',
    MORE_INFO: 'MORE_INFO'
};

const FIVERR_CLIENT_NAME = 'Fiverr';

/**
 * Returns ordered filtered list of notable clients
 *
 * @param {Array<object>} notableClients
 */
export const getDisplayedNotableClients = (notableClients = []) =>
    notableClients.filter(validClient)
        .sort(notableClientsSort);

const notableClientsSort = (clientA, clientB) => clientSortPoints(clientB) - clientSortPoints(clientA);

const validClient = (client) =>
    (client?.enriched_details?.name && client?.enriched_details?.logo);

const clientSortPoints = (client) =>
    !!client.enriched_details.in_fortune * 1000 - client.enriched_details.name.length - (client.enriched_details.name === FIVERR_CLIENT_NAME) * 10000;

const clientV2Points = (client) => (client?.status === EDIT_STATUSES.ENABLED) * 10000 + (client?.status === EDIT_STATUSES.PENDING) * 5000 +
 (!!client.company?.in_fortune || 0) * 1000 - (client.company?.name || client.name).length;

export const notableClientsV2Sort = (clientA, clientB) => clientV2Points(clientB) - clientV2Points(clientA);

export const getClientLogoPath = (client) => client.enriched_details.logo;
export const getClientNewLogoPath = ({ company }) => {
    if (!company) {
        return;
    }
    return company.logo_url;
};

export const getClientName = (client) => client.company?.name || client.name;

export const descriptionHasMore = (description) => {
    if (!description) {
        return [ false, '' ];
    }

    const descriptionWords = description.split(' ');
    const hasMore = descriptionWords.length > WORDS_TO_SHOW_MORE;
    const previewDescription = descriptionWords.slice(0, WORDS_TO_SHOW_MORE).join(' ');
    const threeDots = hasMore ? '...' : '';

    return [ hasMore, previewDescription.concat(threeDots) ];
};

/**
 * Returns Boolean -
 *   If the Notable Clients component should be rendered
 *
 * @param {Array<object>} notableClients
 * @returns {boolean}
 */
export const shouldRenderNotableClients = (notableClients) =>
    !!notableClients?.length;

export const firstBottomLeftPosition = (index) => (index === 0) ?
    Popover.POSITIONS.BOTTOM_LEFT :
    Popover.POSITIONS.BOTTOM;
export const alwaysRight = () => Popover.POSITIONS.RIGHT;
export const automaticPosition = () => undefined;
export const oddsPopoverPositionLeft = (index) => (index % 2 === 0) ?
    Popover.POSITIONS.BOTTOM_LEFT :
    Popover.POSITIONS.BOTTOM;

export const COMPACT_BAR = {
    CLIENTS_LIMIT: 2,
    ELLIPSIS_COUNT: 3
};

export const HIDDEN_CLIENTS_MODE = {
    PLUS: 'plus_mode',
    DOTS: 'dots_mode'
};

const NOTABLE_CLIENTS_UNKNOWN_ORIGIN = 'unknown';
const LISTINGS_OPTIONS = ['search', 'sub_category'];

export const normalizeOrigin = (origin) => {
    let normalized = origin ? origin.replace(/\s+/g, '_').toLowerCase() : NOTABLE_CLIENTS_UNKNOWN_ORIGIN;

    if (LISTINGS_OPTIONS.find((currentOption) => normalized === currentOption)) {
        normalized = SOURCES.LISTINGS;
    }

    return normalized;
};
